import React, {PureComponent} from 'react';

class Jira extends PureComponent {

  jiraTag = this.props.jiraTag;

  render() {
    return <div className="Jira"></div>
  }

  componentDidUpdate() {
    this.refreshJira();
  }

  componentDidMount() {
    this.refreshJira();
  }

  refreshJira() {
    this.cleanJira();
    window.ATL_JQ_PAGE_PROPS = {
      environment: function () {
        var env_info = {};
        return env_info;
      },
      fieldValues: {
        'customfield_10026': this.props.file + ' ' + this.props.location + ' ' + this.props.item,
        'customfield_10100': this.props.file + ' ' + this.props.location + ' ' + this.props.item,
        'customfield_10200': this.props.sco
      }
    }

    const s = document.createElement('script');
    s.id = 'jiraTag';
    s.type = 'text/javascript';
    s.async = true;
    s.src = this.jiraTag;
    document.body.appendChild(s);
  }

  cleanJira() {
    const ids = ['jiraTag', 'atlwdg-trigger', 'atlwdg-blanket', 'atlwdg-container'];
    for (var i = 0; i < ids.length; i++) {
      const elem = document.getElementById(ids[i]);
      if (elem != null) {
        //           document.getElementById(ids[i]).remove();
        elem.parentNode.removeChild(elem);
      }
    }
  }
}

export default Jira;